export function UserDefinedFields(client) {
    return {
        get(masterAccountId) {
            return client.get(`/accounts/${masterAccountId}/user-defined-fields`);
        },
        post(masterAccountId, data) {
            return client.post(`/accounts/${masterAccountId}/user-defined-fields`, data);
        },
        put(masterAccountId, userDefinedFieldId, data) {
            return client.put(`/accounts/${masterAccountId}/user-defined-fields/${userDefinedFieldId}`, data);
        },
        delete(masterAccountId, userDefinedFieldId) {
            return client.delete(`/accounts/${masterAccountId}/user-defined-fields/${userDefinedFieldId}`);
        }
    };
}
